var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.325 3.958 2.237-2.486L2.495.286a.818.818 0 0 0-1.243 0L.257 1.391c-.343.381-.343 1 0 1.381l1.068 1.186ZM2.07 4.787l2.237-2.485.746.828-2.237 2.486-.746-.829ZM16.14 15.645l-2.062 2.29 3.13 1.987a.489.489 0 0 0 .635-.094.636.636 0 0 0 .085-.705l-1.789-3.479ZM3.563 6.445 5.799 3.96l9.684 10.759-2.237 2.485L3.562 6.445ZM11.987 9.171l1.088-1.208c1.33.527 2.836.163 3.85-.963.965-1.072 1.283-2.595.954-3.964-.105-.435-.596-.578-.882-.26l-1.688 1.876-1.491-1.657 1.688-1.876c.286-.318.157-.864-.234-.98C14.04-.226 12.67.127 11.704 1.2c-1.013 1.127-1.34 2.8-.867 4.278L9.75 6.685l2.237 2.486ZM6.017 10.828 4.93 12.036c-1.33-.526-2.837-.163-3.85.964-.966 1.072-1.283 2.595-.955 3.964.105.434.596.577.882.26l1.688-1.876 1.492 1.657-1.688 1.875c-.286.318-.158.864.233.98 1.232.366 2.603.012 3.568-1.06 1.014-1.126 1.34-2.8.867-4.278l1.087-1.208-2.237-2.486Z",
    fill: "#979BA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditMode);
export default __webpack_public_path__ + "static/media/edit_mode.bedafdd664a59789d78ee71bcd7c3358.svg";
export { ForwardRef as ReactComponent };